'use strict';

import debounce from 'lodash/debounce';
import * as progress from './progress';
import {initModules} from '../helpers/utilities';
import {appendParamsToURL, appendParamToURL} from '../helpers/urlUtilities';
import {setOverlay, unsetOverlay, allowScrollableAreas, addEventListenerList} from '../helpers/utilities';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import {callbackOnElements} from '@borngroup/born-utilities';
import modules from '../helpers/modules';
import {plpColorStrap, resetProductAnchors} from '../search/index';

const
    SUGGESTIONS_URL_EL = document.querySelector('[data-suggestions-url]'),
    ENDPOINT = SUGGESTIONS_URL_EL ? SUGGESTIONS_URL_EL.getAttribute('data-suggestions-url') : '',
    MIN_CHARS = 3;

/**
 * Retrieves the closest search container, or the currently available one.
 */
function getSearchContainer(scope) {
    let selector = '[data-search-component="container"]';

    return scope ? scope.closest(selector) : document.querySelector(selector);
}

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - [data-search-component="suggestions-container"] element
 */
function getSuggestionsContainer(scope, emptyContainer) {
    let searchContainer = getSearchContainer(scope),
        suggestionsContainer = searchContainer ? searchContainer.querySelector('[data-search-component="suggestions-container"]') : false;

    if (emptyContainer && suggestionsContainer) {
        suggestionsContainer.textContent = '';

        searchContainer.classList.remove('set--has-results');
    }

    return suggestionsContainer;
}

function _handleSearchTracking(options) {
    if (options.formUrl) {
        let delayedPageView = options.delayPageView ? 1500 : 0;

        //Delay tracking instant search results to prevent logging "false" page views.
        debounce(function() {
            modules.tracking.init(null, {
                trackEvent: 'virtualPageview',
                trackObject: {
                    asyncURL: window.SFRA.Urls.GTMVirtualView,
                    reqPath: appendParamsToURL(window.SFRA.Urls.searchShow, {kwCAR: options.searchTerm, category: options.searchCategory}),
                    qString: options.searchTerm,
                    asyncParams: {
                        pageTemplate: 'Instantsearchpages'
                    }
                }
            });
        }, delayedPageView)();
        resetProductAnchors();
    }

    modules.tracking.init(null, {
        trackEvent: 'search',
        trackObject: {
            searchTerm: options.searchTerm,
            searchCategory: options.searchCategory || 'search'
        }
    });
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response, formUrl, searchTerm) {
    let suggestionsContainer = getSuggestionsContainer(this),
        searchContainer = getSearchContainer(this),
        suggestionsCorrection = $(response).find('.site-search__suggestions-correction');

    if (typeof response !== 'object') {
        initModules(suggestionsContainer);

        searchContainer.classList.add('set--has-results');
        suggestionsContainer.classList.remove('set--invisible');

        if (suggestionsCorrection.length > 0) {
            [].forEach.call(suggestionsCorrection, function(item) {
                let itemText = item.innerHTML.trim(),
                    highlightedContent = itemText.replace(
                        new RegExp(searchTerm, 'g'),
                        (str) => '<span class="highlight">' + str + '</span>'
                    );
                item.innerHTML = highlightedContent;
                item.classList.add('highlighted-suggestion');
                let parser = new DOMParser();
                let parsedHTML = parser.parseFromString(response, 'text/html');
                parsedHTML.body.querySelector('.site-search__suggestions-section').append(item);
                response = parsedHTML.body.innerHTML;
            });
        }

        suggestionsContainer.innerHTML = response;

        _handleSearchTracking({formUrl, searchTerm, searchCategory: 'instantSearch', delayPageView: true});
    } else {
        suggestionsContainer.classList.add('set--invisible');
    }

    progress.hideLoader();
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions() {
    let searchTerm = this.form['q'].value;

    if (searchTerm.length >= MIN_CHARS) {
        let formUrl = appendParamToURL(ENDPOINT, 'q', searchTerm);

        progress.showLoader(getSuggestionsContainer(this));

        if (this.form['cgid'] && this.form['cgid'].checked) {
            formUrl = appendParamToURL(formUrl, 'cgid', this.form['cgid'].value);
        }

        $.ajax({
            context: this,
            url: formUrl,
            method: 'GET',
            success: (response) => processResponse(response, formUrl, searchTerm),
        });

    } else if (searchTerm.length == 0 || searchTerm.length < MIN_CHARS) {
        let formUrl = appendParamToURL(ENDPOINT, 'q', searchTerm);

        progress.showLoader(getSuggestionsContainer(this));

        if (this.form['cgid'] && this.form['cgid'].checked) {
            formUrl = appendParamToURL(formUrl, 'cgid', this.form['cgid'].value);
        }

        $.ajax({
            context: this,
            url: formUrl,
            method: 'GET',
            success: (response) => processResponse(response, formUrl, searchTerm),
        });
    } else {
        getSuggestionsContainer(this, false);
    }
}

/**
 * Prevents submitting an empty search from the searchbar.
 * @return {[type]} [description]
 */
function preventEmptySearch() {
    addEventListenerList('[data-search-component="form"]', 'submit', function(evt) {
        let currentInput = this.querySelector('[data-search-component="query-input"]');

        if (!currentInput.value.trim()) {
            evt.preventDefault();

            return false;
        } else {
            _handleSearchTracking({searchTerm: currentInput.value});
        }
    });
}

function setupSearchTrigger() {
    callbackOnElements('[data-search-component="trigger"]', function(currentTrigger) {
        if (currentTrigger && currentTrigger.toggle) {
            currentTrigger.toggle.afterSet = function() {
                let queryInputEl = currentTrigger.toggle.targetEl.querySelector('[data-search-component="query-input"]');

                disableBodyScroll(currentTrigger.toggle.targetEl, {allowTouchMove: allowScrollableAreas});

                setOverlay({trigger: 'searchbar'});

                getSuggestions.call(queryInputEl);

            };

            currentTrigger.toggle.afterUnset = function() {
                enableBodyScroll(currentTrigger.toggle.targetEl);

                unsetOverlay({trigger: 'searchbar'});
            };
        }
    });
    plpColorStrap();
}

export function sliderSearchNav(container) {
    var scrollDuration = 200;
    var leftArrow = $(container).find('.search-nav__arrow--left');
    var rightArrow = $(container).find('.search-nav__arrow--right');
    // get items dimensions
    let navItem = $(container).find('.tab-nav').children('.search-results__nav-item');
    let itemWidth = 0;
    $.each(navItem, function(i, value) {
        itemWidth = $(value).outerWidth(true) + itemWidth;
    });
    var paddleMargin = 20;

    // get wrapper width
    var getNavigationWrapper = function() {
        return $(container).outerWidth();
    }

    var searchNavWrapperSize = getNavigationWrapper();

    window.addEventListener('resize', function() {
        searchNavWrapperSize = getNavigationWrapper();
    });

    // get total width of all menu items
    var getNavSize = function() {
        return itemWidth;
    };
    var navSize = getNavSize();
    // get how much of menu is invisible
    var navInvisibleSize = navSize - searchNavWrapperSize;

    var getNavPosition = function() {
        return $(container).find('.tab-nav').scrollLeft();
    };

    $(container).find('.tab-nav').on('scroll', function() {
        // get how much of menu is invisible
        navInvisibleSize = navSize - searchNavWrapperSize;
        // get how much have we scrolled so far
        var navPosition = Math.abs(getNavPosition());

        var navEndOffset = navInvisibleSize - paddleMargin;

        if (navPosition <= paddleMargin) {
            leftArrow.addClass('hidden');
            rightArrow.removeClass('hidden');
        } else if (navPosition < navEndOffset) {
            // show both paddles in the middle
            leftArrow.removeClass('hidden');
            rightArrow.removeClass('hidden');
        } else if (navPosition >= navEndOffset) {
            leftArrow.removeClass('hidden');
            rightArrow.addClass('hidden');
        }

    });

    if (searchNavWrapperSize > itemWidth && rightArrow && !$(rightArrow).hasClass('hidden')) {
        $(rightArrow).addClass('hidden');
    } else if (searchNavWrapperSize < itemWidth && rightArrow && $(rightArrow).hasClass('hidden')) {
        $(rightArrow).removeClass('hidden');
    }

    // scroll to left
    $(rightArrow).on('click', function() {
        if ($('html').attr('dir') == 'rtl') {
            $(container).find('.tab-nav').animate({
                scrollLeft: getNavPosition() - 250
            }, scrollDuration);
        } else {
            $(container).find('.tab-nav').animate({
                scrollLeft: getNavPosition() + 250
            }, scrollDuration);
        }
    });

    // scroll to right
    $(leftArrow).on('click', function() {
        if ($('html').attr('dir') == 'rtl') {
            $(container).find('.tab-nav').animate({
                scrollLeft: getNavPosition() + 250
            }, scrollDuration);
        } else {
            $(container).find('.tab-nav').animate({
                scrollLeft: getNavPosition() - 250
            }, scrollDuration);
        }
    });
}

export function searchResultNavActive() {
    let resultNavItem = document.querySelectorAll('.search-results__nav-item'),
        searchContainerElement = document.querySelector('.search-results__container');
    resultNavItem.forEach(function(item) {
        item.addEventListener('click', function() {
            let attr = item.getAttribute('aria-controls');
            searchContainerElement.setAttribute('data-active-result', attr);
        });
    });
}

searchResultNavActive();
$(document).ready(function() {
    sliderSearchNav($('.search-results__nav'));
})

/**
 * Toggle search bar off when megamenu is opened.
 */
export function closeSearch() {
    let searchTrigger = document.querySelector('[data-search-component="trigger"].toggle--active');

    if (searchTrigger && searchTrigger.toggle) {
        searchTrigger.toggle.unset();
    }
}

export default function() {
    let searchInputs = document.querySelectorAll('[data-search-suggestions] [data-search-component*="input"]'),
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        debounceSuggestions = debounce(getSuggestions, 300);

    [].forEach.call(searchInputs, function(currentInput) {
        currentInput.addEventListener('input', debounceSuggestions);
    });

    preventEmptySearch();
    setupSearchTrigger();

    document.body.addEventListener('click', function(evt) {
        if (!evt.target.closest('[data-search-component="container"]')) {
            getSuggestionsContainer(false, true);
        }
    });

    let searchCloseButton = document.querySelector('.search-close-btn');
    if (searchCloseButton) {
        searchCloseButton.addEventListener('click', function() {
            closeSearch();
        })
    }
}
